import { CalendarMode, CalendarSlotStatus, DsLayout, TIME_FORMAT } from "shared/constants";
import moment from "moment";
import { EventApi } from '@fullcalendar/core';
//import { Tooltip } from "@ds/ds-snam/react";
import { Icon } from "@ds/ds-snam/react";
import { Tooltip } from 'react-tooltip';
import styles from "views/b2bView/components/calendarView/styles/calendarEventContent.module.css";
import TooltipIcon from "components/TooltipIcon";
import DsBadge from "components/DsBadge";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";

interface ICalendarEventContentProps {
    event: EventApi,
    mode: CalendarMode
}
const CalendarEventContent: React.FC<ICalendarEventContentProps> = (props): JSX.Element => {
    const { event, mode } = props;
    const { t, i18n } = useTranslation(["b2b", "app"]);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const getBookingBadgeStatus = (status: string) => {
        let retVal: string = "";
        switch (status) {
            case CalendarSlotStatus.CLOSED://"6"
                retVal = "custom";
                break;
            case CalendarSlotStatus.CONFIRMED://"1"
                retVal = "confirm";
                break;
            case CalendarSlotStatus.PENDING://"2"
                retVal = "warning";
                break;
            case CalendarSlotStatus.REJECTED://"3"
                retVal = "error";
                break;
            default:
                break;
        }
        return retVal;
    }

    return (
        <div style={{ color: layoutMode===DsLayout.DARK_MODE?"white":"black", padding: "4px",paddingTop:'10px', fontSize: "10px" }}>
            {event.extendedProps.slotStatus !== CalendarSlotStatus.NON_WORKING_DAY && <>{mode === CalendarMode.DAY ?
                <div>{moment(event?.start).format(TIME_FORMAT)} - {moment(event?.end).format(TIME_FORMAT)}</div>
                :
                <div>
                    <div>{moment(event?.start).format(TIME_FORMAT)}</div>
                    <div>{moment(event?.end).format(TIME_FORMAT)}</div>
                </div>
            }</>}
            
            <div style={{width:'fit-content'}}>
                <div style={{float:'left'}}>
                    <div style={{paddingTop:'7px'}}>{event.extendedProps.slotStatus !== CalendarSlotStatus.NON_WORKING_DAY?event?.title:t('calendar.title.4')}</div>
                </div>
            </div>
                
            {/* Reservations list */}
            {event.extendedProps.slotStatus !== CalendarSlotStatus.NON_WORKING_DAY && <>
                <div style={{width:'fit-content'}}>
                    <div style={{float:'left'}}>
                        <div style={{paddingTop:'4px'}}>{t('calendar.title.3')+ " " + event.extendedProps.slotsAvailable}</div>
                    </div>
                </div>
            </>}

            {event.extendedProps.reservations && mode === CalendarMode.DAY && event.extendedProps.reservations.length!==0 &&
                <div style={{width:'fit-content'}}>
                    <div style={{float:'left'}}>
                        <div style={{paddingTop:'4px',paddingRight:'2px'}}>
                            {event.extendedProps.reservations.map((reservation: { label: string, status: string }, index: number) => {
                                return (
                                    <div key={`${reservation.label}-${index}`} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}>
                                        {reservation.status === CalendarSlotStatus.AVAILABLE ?//"0"
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "16px", height: "16px" }}>
                                                <div style={{ borderRadius: "50%", border: "2px solid #6983AF", width: "14px", height: "14px", backgroundColor: "#fff" }}></div>
                                            </div>
                                        :
                                            <DsBadge notificationStatus={getBookingBadgeStatus(reservation.status)} isSmall={true} backgroundColor={getBookingBadgeStatus(reservation.status)==="custom"?"#320216":undefined}/>
                                        }
                                        <span>
                                            {reservation.label}
                                        </span>
                                    </div>
                                )
                            })}
                            {/**
                              
                             NELL'EVENTO GIORNALIERO LE PRENOTAZIONI RIFIUTATE HANNO COME LABEL "Pending Reservation",
                             E' un errore lato BE infatti la /calendar-slots nelle extended props mi restitusice:
                             * "reservations": [
                                    {
                                        "label": "Pending reservations: 1", <---------------
                                        "status": "2"
                                    },
                                    {
                                        "label": "Pending Reservations: 1",  <---------------
                                        "status": "3"
                                    },
                                    {
                                        "label": "Closed Reservations: 1",
                                        "status": "6"
                                    }
                                ]
                             */}
                        </div>
                    </div>
                </div>
            }


            {event.extendedProps.slotStatus !== CalendarSlotStatus.NON_WORKING_DAY && <>
                <div style={{width:'fit-content'}}>
                    <div style={{float:'left'}}>
                        <div style={{paddingTop:'4px'}}><TooltipIcon tooltipId="calendar-event-tooltip" tooltipData={event?.extendedProps['tooltip']}/></div>
                    </div>
                </div>
            </>  }

            
            
            

        </div>
    )
}

export default CalendarEventContent